import { createContext, useContext } from "react";

export interface SearchContextValue {
  query: string;
}

export const SearchContext = createContext<SearchContextValue>({ query: "" });

export const useShowcaseSearchQuery = () => useContext(SearchContext).query;

export const matchesShowcaseQuery = (title: string, query: string) => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;
  return title.toLowerCase().includes(normalized);
};
